// extracted by mini-css-extract-plugin
module.exports = {"selectedView":"styles_selectedView__1nDZ-","blackButton":"styles_blackButton__WtW0V","ant-btn-primary":"styles_ant-btn-primary__1B0vf"};